<template>
  <div v-title="docTitle">
    <order-review-layout v-loading="requestLoading || viewLoading"
                         :element-loading-text="loadingText"
                         element-loading-background="transparent">
      <template v-slot:top>
        <order-review-info-panel @question-collapse="questionCollapse"></order-review-info-panel>
      </template>
      <template v-slot:right>
        <order-review-sidebar-panel></order-review-sidebar-panel>
      </template>
      <order-review-question-panel
        v-if="!requestLoading && !allowLiveOrderReview"
        v-show="!viewLoading">
      </order-review-question-panel>

      <order-live-review-panel v-if="!requestLoading && allowLiveOrderReview"
                                v-show="!viewLoading">
      </order-live-review-panel>
    </order-review-layout>
  </div>
</template>

<script>
import OrderLiveReviewPanel from '@views/order-review/pages/OrderLiveReviewPanel'
import OrderReviewInfoPanel from '@views/order-review/pages/OrderReviewInfoPanel'
import OrderReviewLayout from '@views/order-review/pages/OrderReviewLayout'
import OrderReviewQuestionPanel from '@views/order-review/pages/OrderReviewQuestionPanel'
import OrderReviewSidebarPanel from '@views/order-review/pages/OrderReviewSidebarPanel'
import CacheManage from '@views/question-review/components/CacheManage'
import questionReview from '@views/question-review/question-review.js'
import '@views/question-review/question-review.scss'

export default {
  components: {
    OrderReviewLayout,
    OrderReviewInfoPanel,
    OrderReviewSidebarPanel,
    OrderReviewQuestionPanel,
    OrderLiveReviewPanel,
  },
  mixins: [],
  provide () {
    return {
      page: this,
    }
  },
  data () {
    return {
      id: null,
      questions: [],
      questionRefs: [],
      answers: [],
      requestLoading: false,
      viewLoading: false,
      loadingText: '拼命加载中',
      answerChangeTotal: 0,
      questionMatchProduct: {},
      questionJoinImage: {},
      modifyAnswerQuestions: {},
      questionContainerElement: null,
      throughRecords: [],
      firstAnswerPhotos: [],
      isOpenThroughRecord: false,

      // sjf订单信息数据
      sjfOrderDetail: null,

      // 页面只读，不审核
      readonly: this.$route.query.readonly
    }
  },
  computed: {
    ...Vuex.mapState({
      user: state => state.login.user,
    }),
    ...Vuex.mapState({
      orderDetail: state => state.orderReview.orderDetail,
      cacheAnswers: state => state.orderReview.cacheAnswers,
    }),
    ...Vuex.mapGetters('orderReview', [
      'allowLiveOrderReview',
    ]),
    docTitle () {
      if (this.orderDetail && this.orderDetail.title) {
        return this.orderDetail.title + ' - ' + this.$route.meta.title
      }
      return this.$route.meta.title
    },
  },
  watch: {
    answers: {
      handler (val) {
        // 第一次是vue初始化，第二次是值初始化
        if (this.answerChangeTotal++ && !this.requestLoading) {
          this.setCache()
        }
        this.$store.commit('orderReview/SET_PHOTO_COUNT', questionReview().getAnswerPhotoCount())
      },
      deep: true,
    },
    cacheAnswers (answers) {
      if (answers) {
        this.requestLoading = true
        this.$nextTick(() => {
          questionReview().setAnswers(answers)
          setTimeout(() => {
            this.requestLoading = false
          }, 100)
        })
      }
    },
    $route () {
      this.$router.go(0)
      Object.assign(this.$data, this.$options.data.call(this))
    }
  },
  beforeCreate () {
    this.$store.commit('COLLAPSE_MENU')
    // 对上一次缓存的临时缓存，转移到版本缓存中
    CacheManage.moveTempToVersionItem()
  },
  async created () {
    this.id = this.$route.params.id
    // 清空粘贴数据
    this.deleteLocalStorageForCopy()

    if (!this.id) return

    this.init(this.id)
  },
  mounted () {},
  destroyed () {
    CacheManage.destroy()
    questionReview.destroy()
    // 清空工单数据
    this.$store.commit('orderReview/SET_ORDER_DETAIL_DATA', {})
    this.$store.commit('orderReview/SET_ASR_CHECK_RESULT', null)
    this.$store.commit('orderReview/SET_ASR_CHECK_SEEK', null)
    // sjf 业务
    this.$store.commit('orderReview/SET_SJF_ORDER_DETAIL_DATA', {})
  },
  methods: {
    ...Vuex.mapActions([]),
    // 获得工单审核历史的问题是否修改状态
    getOrderReviewHistoryQuestionStatus (id) {
      request('getOrderReviewHistoryQuestionStatus', {id}).then(({data}) => {
        let questions = {}
        data.forEach(({stepId, edited}) => {
          questions[stepId] = edited
        })
        this.modifyAnswerQuestions = questions
      })
    },
    // 从识别结果中判断答案是否通过
    recognitionAnswerPassed () {
      // todo 旺哥试验功能
      // 待获取识别结果的问题列表
      let recQuestions = []
      // 『以上都没有』的选项
      let noneOptions = {}
      // 获取有效的问题列表
      let validQuestions = questionReview().getValidQuestions()
      for (let question of validQuestions) {
        if (question.type === 'multiselect') {
          question.options.forEach((option) => {
            recQuestions.push({
              title: option.title,
              questionId: question.id,
              optionId: option.id,
            })
            // 存在以上都没有的选项ID
            if (option.title === '以上都没有') {
              noneOptions[question.id] = option.id
            }
          })
        }
      }
      request.loading('matchRecognitionQuestionProduct', {
        orderId: this.orderDetail.orderid,
        data: recQuestions,
      }).then(({data}) => {
        // 获得匹配问题ID索引
        let matchMap = {}
        let matchedOptions = {}
        // todo 仅仅完成多选题
        data.data.forEach((data) => {
          let {questionId, optionId, matched} = data
          if (optionId) {
            if (!matchMap[questionId]) {
              matchMap[questionId] = {
                isPassed: null,
                options: {},
              }
            }
            matchMap[questionId].options[optionId] = data
          }
          // 获取匹配成功的选项ID
          if (!matchedOptions[questionId]) {
            matchedOptions[questionId] = []
          }
          if (matched) {
            matchedOptions[questionId].push(optionId)
          }
        })
        // 得出『以上都没有』的答案
        for (let questionId in matchedOptions) {
          if (matchedOptions.hasOwnProperty(questionId)) {
            // 没有匹配到任何答案
            if (!matchedOptions[questionId].length) {
              // 存在『以上都没有』的答案选项
              if (noneOptions[questionId]) {
                matchedOptions[questionId].push(noneOptions[questionId])
              }
            }
          }
        }
        // 判断是否题目通过
        validQuestions.forEach(({id, options, type}) => {
          // 必须多选题 并且有 识别匹配的有效数据
          if (type === 'multiselect' && matchedOptions[id]) {
            // 判断识别出产品的选项ID和用户选择的答案ID是否一致
            if (_.isEqual(matchedOptions[id].sort(), questionReview().getAnswer(id).selectedOptionId.sort())) {
              if (!questionReview().isReviewed(id)) {
                questionReview().reviewPassed(id)
              }
              matchMap[id].isPassed = true
            } else {
              matchMap[id].isPassed = false
            }
          }
        })
        this.questionMatchProduct = matchMap
      })
    },
    getOrderReviewQuestionJoinImg () {
      request('getOrderReviewQuestionJoinImg', {id: this.orderDetail.orderid}).then(({data}) => {
        this.questionJoinImage = data.splice_question
      })
    },
    setCache () {
      // 记录本次缓存的数据已变化次数
      let answerChangeTotal = this.answerChangeTotal
      // 延迟500毫秒保存数据
      setTimeout(() => {
        // 数据还处于变化中，等待变化完毕后执行缓存
        if (answerChangeTotal === this.answerChangeTotal) {
          CacheManage.setItem(
            this.orderDetail.orderid + '_' + this.orderDetail.templatesnapshotid,
            questionReview().getAnswers(),
          ).then(() => {
            this.$message.success('已缓存审核结果')
          }, () => {
            this.$message.error('自动缓存审核结果失败')
          })
        }
      }, 3000)
    },
    handleOrderDetail () {
      this.loadingText = '数据处理中'
      // 异步使视图先更改
      setTimeout(() => {
        // 数据处理中 视图更改完毕
        this.$nextTick(() => {
          questionReview().init(
            JSON.parse(this.orderDetail.templatejson).steps,
            this.orderDetail.templateresultjson ? JSON.parse(this.orderDetail.templateresultjson) : null)

          // 判断识别结果与答案是否通过
          this.recognitionAnswerPassed()

          // 获得题目拼接的照片
          this.getOrderReviewQuestionJoinImg()
          this.$set(this, 'questions', questionReview().getQuestions())
          this.$set(this, 'answers', questionReview().getAnswers())
          questionReview().setExtendedStepsStart(JSON.parse(this.orderDetail.templatejson).extended_steps_start)

          // 开启了全程录音, 需要数据追加
          if (this.isOpenThroughRecord) {
            this.questions[0].evidenceType = 'record'
            this.answers[0].evidences = this.throughRecords.map(src => {
              return {
                src,
                type: 'record'
              }
            })
          }

          this.loadingText = '视图加载中'
          // 异步使视图先更改
          setTimeout(() => {
            this.requestLoading = false
            // 视图加载中 视图更改完毕
            this.$nextTick(() => {
              // 异步使视图先更改
              setTimeout(() => {
                // 全部加载完成 视图更改完毕
                this.$nextTick(() => {
                  this.viewLoading = false
                })
              })
            })
          })
        })
      })
    },
    init (id) {
      this.loadingText = '请求加载中'
      this.requestLoading = true
      this.viewLoading = true
      request.page('getOrderDetail', {id}).then((res) => {
        this.$store.commit('orderReview/SET_ORDER_DETAIL_DATA', res.data)
        this.loadAsrCheckResult(id)
        this.loadErrorMessages()
        this.handleOrderDetail()
        this.fetchTaskAuditReference(res.data.taskid)
        const templatejson = JSON.parse(res.data.templatejson)
        this.isOpenThroughRecord = templatejson.through_record === '1'
        if (this.isOpenThroughRecord) {
          const answers = res.data.templateresultjson ? JSON.parse(res.data.templateresultjson) : []
          if (answers.length > 0 && answers[0].records) {
            this.throughRecords = answers[0].records
          }
          if (answers.length > 0 && answers[0].photos) {
            this.firstAnswerPhotos = answers[0].photos
          }
        }
        // 仅审核通过需要显示 答案是否被修改
        this.getOrderReviewHistoryQuestionStatus(this.id)

        // sjf 任务
        if (res.data.type === '23') {
          this.fetchSjfOrderDetail(res.data.taskid)
        }
      })
    },
    loadAsrCheckResult (id) {
      request.common('getAudioAsrCheckOrderResult', {id}).then(({data}) => {
        this.$store.commit('orderReview/SET_ASR_CHECK_RESULT', data || null)
      }).catch(() => {
        this.$store.commit('orderReview/SET_ASR_CHECK_RESULT', null)
      })
    },
    fetchSjfOrderDetail (id) {
      Promise.all([request.common('getSJFOrderDetail', { id }), request.common('getSJFPlatformSetting')]).then(([{data}, {data: setting}]) => {
        this.sjfOrderDetail = data
        this.sjfOrderDetail.template_questions = setting.template_questions
        this.$store.commit('orderReview/SET_SJF_ORDER_DETAIL_DATA', data)
      })
    },
    fetchTaskAuditReference (taskid) {
      if (!taskid) {
        this.$store.commit('orderReview/SET_TASK_AUDIT_REFERENCE', null)
        return
      }
      request.common('getTaskAuditReference', {taskid}).then(({data}) => {
        this.$store.commit('orderReview/SET_TASK_AUDIT_REFERENCE', data || null)
      }).catch(() => {
        this.$store.commit('orderReview/SET_TASK_AUDIT_REFERENCE', null)
      })
    },
    questionCollapse (bool) {
      this.questionRefs.forEach((question) => {
        question.showBody = !bool
      })
    },
    loadErrorMessages () {
      request.page('getQuestionNotPassMessageDetail', {batch_id: this.orderDetail.batchid}).then(({data}) => {
        data && this.$store.commit('orderReview/SET_ERROR_MESSAGES', data.error_msg || [])
      })
    },
    deleteLocalStorageForCopy () {
      localStorage.removeItem('copyForReloadReviewData')
      localStorage.removeItem('copyForReloadReviewDataType')
      localStorage.removeItem('copyForQrcode')
    },
  },
}
</script>
<style lang="scss"
       scoped></style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/order-review/pages/OrderReview.vue